import { useEffect } from "react";
import { useAppLoading } from "../context/AppLoadingContext";
import { preloadImage } from "../lib/preloadImage";

export function useTrackedImagePreload(src) {
  const { trackAsync } = useAppLoading();

  useEffect(() => {
    if (!src) {
      return undefined;
    }

    void trackAsync(() => preloadImage(src));

    return undefined;
  }, [src, trackAsync]);
}
